import { Progress } from "@base-ui/react/progress";
import styles from "./ProgressBar.module.css";
// @ts-expect-error pure js
import { classnames } from "../../utils";

export type ProgressBarColor = "primary" | "success";

interface ProgressBarProps {
  value: number;
  /** Valeur correspondant à 100 %. Défaut : 100. */
  max?: number;
  color?: ProgressBarColor;
  /** Nom accessible : à fournir quand aucun libellé visible n'accompagne la barre. */
  label?: string;
  className?: string;
}

export default function ProgressBar({
  value,
  max = 100,
  color = "primary",
  label,
  className,
}: ProgressBarProps) {
  return (
    <Progress.Root
      value={value}
      max={max}
      aria-label={label}
      className={classnames(styles.root, className)}
    >
      <Progress.Track className={styles.track}>
        <Progress.Indicator
          className={classnames(styles.fill, styles[color])}
        />
      </Progress.Track>
    </Progress.Root>
  );
}
